import { userHasLevel1OnlyAccess } from "@utils/projectAccess";
import * as RouteHelper from "@utils/paths";
import { ContractorPackageLineItem } from "catchment-common/interfaces/contractorPackage";
import { OrganisationLineItem } from "catchment-common/interfaces/organisation";
import { ProjectLineItem } from "catchment-common/interfaces/project";
import { SideBarMenuModelLineItem } from "catchment-common/interfaces/sidebarMenu";
import { NavItemType } from "types";

import { safeUrl } from "./menuItemUrl";
import Icon from "@ui/atoms/Icon/Icon";

const monthlyReportsItem = (
  project?: ProjectLineItem,
  contractorPackage?: ContractorPackageLineItem,
  sideBarMenuModel?: SideBarMenuModelLineItem
): NavItemType => ({
  badge: sideBarMenuModel?.packageReportSocialCount,
  icon: <Icon name="file-check" />,
  id: "monthly-reports",
  title: "Monthly Reports",
  type: "item",
  url: safeUrl(project, contractorPackage, () =>
    RouteHelper.contractorPackageReports(project!.id, contractorPackage!.id)
  )
});

export const getReportsNav = (
  project?: ProjectLineItem,
  contractorPackage?: ContractorPackageLineItem,
  sideBarMenuModel?: SideBarMenuModelLineItem
): NavItemType => {
  const children = [];

  // Level1Only (shared) users see only Project Reports — not Monthly Reports.
  if (!userHasLevel1OnlyAccess(project)) {
    children.push(
      monthlyReportsItem(project, contractorPackage, sideBarMenuModel)
    );
  }

  children.push({
    icon: <Icon name="share" />,
    id: "project-reports",
    title: "Project Reports",
    type: "item",
    url: safeUrl(project, contractorPackage, () =>
      RouteHelper.projectReports(project!.id, contractorPackage!.id)
    )
  });

  return {
    children,
    id: "submit",
    // Caption dropped for the shared (Level1Only) nav — see `getPackageNav`.
    title: userHasLevel1OnlyAccess(project) ? undefined : "submit",
    type: "group"
  };
};

export const getReducedReportNav = (
  project?: ProjectLineItem,
  contractorPackage?: ContractorPackageLineItem,
  organisation?: OrganisationLineItem,
  sideBarMenuModel?: SideBarMenuModelLineItem
): NavItemType => {
  const children = [];

  // Level1Only (shared) users see only Subpackage Reports — not Monthly Reports.
  if (!userHasLevel1OnlyAccess(project)) {
    children.push(
      monthlyReportsItem(project, contractorPackage, sideBarMenuModel)
    );
  }

  if (organisation?.subpackageEnabled) {
    children.push({
      icon: <Icon name="share" />,
      id: "project-reports",
      title: "Subpackage Reports",
      type: "item",
      url: safeUrl(project, contractorPackage, () =>
        RouteHelper.subpackageReports(project!.id, contractorPackage!.id)
      )
    });
  }

  return {
    children,
    id: "submit",
    // Caption dropped for the shared (Level1Only) nav — see `getPackageNav`.
    title: userHasLevel1OnlyAccess(project) ? undefined : "submit",
    type: "group"
  };
};
